import React from "react";
import * as types from "src/types";
import { Router, Route, Switch ,Redirect} from "react-router-dom";
import { createBrowserHistory } from "history";
import indexRoutes, {getRoutes} from "./index";
import { connect } from "react-redux";

interface IRouterProps {
  connect: types.IState;
}
interface IRouterState {}
const hist = createBrowserHistory();
window['hist']=hist;
class MainRouter extends React.Component<IRouterProps, IRouterState> {
  lastRoute:any;
  render() {
  
  
 
   
    const reload = () => window.location.reload();

    return (
      <Router history={hist}>
        <Switch>
        <Route path="/www" onEnter={reload} />

          {getRoutes(this.props.connect).map((prop, key) => {
            if(prop.redirect)
            {
              return ( <Redirect from={prop.path} to={prop.pathTo} />)
            }
            return (
              <Route path={prop.path} component={prop.component} key={key} />
            );
          })}
        
        </Switch>
      </Router>
    );
  }
}
export function mapStateToProps(state: types.IState) {
  return {
    connect: state
  };
}
export default connect(
  mapStateToProps,
  null
)(MainRouter);



// WEBPACK FOOTER //
// ./src/routes/Router.tsx